<template>
  <div>
    <b-field :label="$t('catalogue.newProduct.restrictionAffichage.restricitionAffichageEdition')"
             v-if="!visualisation">
      <b-input type="textarea" v-model="produit.restrictionsAffichage"
               :disabled="isSynchro">
      </b-input>
    </b-field>
    <b-field :label="$t('catalogue.newProduct.restrictionAffichage.restricitionAffichage')"
             custom-class="has-text-default is-italic has-text-weight-light"
             v-else>
       <span class="has-text-weight-bold"> {{ produit.restrictionsAffichage }} </span>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'CatalogueRestriction',
  props: {
    produit: {
      type: Object,
      required: true,
    },
    visualisation: {
      type: Boolean,
      required: false,
      default: false,
    },
    typeFace: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    isSynchro() {
      if (!this.$route.params.produitId) return false;
      if (this.typeFace) {
        return this.produit.faceId !== null;
      }
      return this.produit.materielId !== null;
    },
  },
};
</script>

<style scoped>

</style>
